/*@ngInject*/
const UserListActionRepository = function (baseRepository, temporaryLoginTokenRepository) {

    angular.extend(this, baseRepository);

    this.importUWLOAs = function (file) {
        let url = '/underWriterLOAImport/UnderWriterLOAImportServlet',
            formData = new FormData(),
            config = {
                transformRequest: angular.identity,
                params: {
                    fileName: file.name,
                    size: file.size
                },
                // When you assign undefined, the content type defaults to multipart/form-data
                headers: {
                    'Content-Type': undefined
                }
            };

        formData.append('file', file);

        return temporaryLoginTokenRepository.getSingleUseToken().then((token) => {
            config.params.t = token;
            return this.post(url, formData, config);
        });
    };

    this.exportUWLOAs = function () {
        let url = '/underWriterLOAExport/UnderWriterLOAExportServlet',
            config = {
                params: {}
            };

        return temporaryLoginTokenRepository.getSingleUseToken().then((token) => {
            config.params.t = token;
            return this.get(url, config);
        });
    }
};

angular.module('umCore')
    .service('userListActionRepository', UserListActionRepository);
